// extracted by mini-css-extract-plugin
export default {"section":"PerformanceSummaryMetrics_section__5nhwk","grid":"PerformanceSummaryMetrics_grid__6TIzT"};